import { z } from 'zod';

// Everything with a VITE_ prefix is inlined into the client bundle and is
// therefore public. Never put a secret here.
const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  // The identity provider's issuer URL, exactly as it appears in the `iss` claim
  // of the tokens it mints — the backend validates against the same string, so a
  // trailing slash or a different host here rejects every token with an error
  // that points nowhere useful. Held whole rather than assembled from host and
  // realm so there is nothing to assemble wrongly.
  VITE_OIDC_AUTHORITY: z.string().url(),
  VITE_OIDC_CLIENT_ID: z.string().min(1),
  // Whether navigation offers sections that are still placeholders (Library,
  // Agents & skills, Audit trail). Off by default (spec 099 FR-008): a door
  // onto one sentence costs trust every time it is tried. Anything but the
  // literal `true` is off.
  VITE_SHOW_UNBUILT_SECTIONS: z
    .string()
    .optional()
    .default('false')
    .transform((value) => value === 'true'),
});

const runtimeEnv = (typeof window !== 'undefined' && window.__ENV__) || {};

const parsed = envSchema.safeParse({
  VITE_API_BASE_URL:
    runtimeEnv.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL,
  VITE_OIDC_AUTHORITY:
    runtimeEnv.VITE_OIDC_AUTHORITY || import.meta.env.VITE_OIDC_AUTHORITY,
  VITE_OIDC_CLIENT_ID:
    runtimeEnv.VITE_OIDC_CLIENT_ID || import.meta.env.VITE_OIDC_CLIENT_ID,
  VITE_SHOW_UNBUILT_SECTIONS:
    runtimeEnv.VITE_SHOW_UNBUILT_SECTIONS ||
    (import.meta.env.VITE_SHOW_UNBUILT_SECTIONS as string | undefined),
});

if (!parsed.success) {
  throw new Error(
    `Missing or invalid environment variables:\n${parsed.error.issues
      .map((issue) => `  ${issue.path.join('.')}: ${issue.message}`)
      .join(
        '\n',
      )}\n\nCopy .env.example to .env.local and fill in the required values.`,
  );
}

export const env = parsed.data;
